import React, { useEffect, useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  IconButton,
  Box,
  Menu,
  MenuItem,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Divider,
  useTheme,
  useMediaQuery,
  Badge,
  Avatar,
  Chip,
  Container
} from "@mui/material";
import {
  Menu as MenuIcon,
  Home,
  LocalShipping,
  ShoppingBag,
  Event,
  TableRestaurant,
  QrCode,
  ShoppingCart,
  LocationOn,
  Phone,
  DarkMode,
  LightMode,
  Store,
  Person,
  Logout,
  CardTravel,
  PersonAdd,
  ArrowForward,
} from "@mui/icons-material";
import { useNavigate, useLocation } from "react-router-dom";
import { useRestaurant } from "../../contexts/RestaurantContext";
import { useCustomTheme } from "../../contexts/ThemeContext";
import { getImageProps } from "../../utils/imageUtils";
import OutletSelectionModal from "./OutletSelectionModal";
import CartDrawer from "./CartDrawer";
import LoginModal from "./LoginModal";
import { themeColorConfig } from "../Themes/themeColorConfig";
import ContactModal from "./ContactModal";
import { useNotification } from "../../contexts/NotificationContext";
import { Outlet } from "react-router-dom";

// Updated color scheme to match the design
const navColor = {
  bg: "#FFFEF5",
  primary: "#6B2D14",
  primaryHover: "#4A1D0D",
  text: "#2C1810",
  textSecondary: "#8B7355",
  white: "#FFFFFF",
  hover: "#F5E6D3",
  border: "#E5D4C1",
};

const UserNavbar = () => {
  const pageUrl = window.location.pathname;
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [locationMenuOpen, setLocationMenuOpen] = useState(false);
  const [locationAnchor, setLocationAnchor] = useState(null);
  const [cartOpen, setCartOpen] = useState(false);
  const [outletSelection, setOutletSelection] = useState({});
  const [showImage, setShowImage] = useState(true);
  const [loginModalOpen, setLoginModalOpen] = useState(false);
  const [loginMenuOpen, setLoginMenuOpen] = useState(false);
  const [actualServiceType, setActualServiceType] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [contactModalOpen, setContactModalOpen] = useState(false);
  const open = Boolean(anchorEl);

  // const location = useLocation();


  const handleClose = () => {
    setAnchorEl(null);
  };

  const { loginUser } = useRestaurant();
  // console.log(loginUser, "loginUser");

  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const { showSuccess, showError } = useNotification();
  const isTableOrderRoute = location.pathname.startsWith('/tableorder') || location.pathname.startsWith('/table-checkout');

  const {
    cart,
    restaurant,
    selectedOutlet,
    getCartItemCount,
    outlets,
    selectOutlet,
    isDeliveryAvailable,
    isTakeawayAvailable,
    isDineInAvailable,
    showOutletSelectionModal,
    handleOutletSelection,
    showOutletSelection,
    closeOutletSelection,
    loadRestaurantData,
  } = useRestaurant();

  useEffect(() => {
    loadRestaurantData();
  }, []);

  useEffect(() => {
    // console.log("anchorEl changed:", anchorEl);
  }, [anchorEl]);

  const { isDarkMode, toggleTheme } = useCustomTheme();

  const cartItemCount = getCartItemCount ? getCartItemCount() : 0;

  const navigationItems = [
    { label: "Home", path: "/home", icon: <Home /> },
    // { label: "Catering", path: "/catering", icon: <Event /> },
    // {
    //   label: "Reservation",
    //   path: "/table-reservations",
    //   icon: <TableRestaurant />,
    // },
    { label: "Contact Us", path: "/contact", icon: <Phone /> },
    { label: "Order Online", path: "/delivery", icon: <ArrowForward /> },
  ];

  const handleNavigation = (path) => {
    navigate(path);
    setMobileMenuOpen(false);
  };

  const handleLocationMenuOpen = (event) => {
    setLocationAnchor(event.currentTarget);
    setLocationMenuOpen(true);
  };

  const iconStyles = {
    fontSize: {
      xs: "1rem !important",
      sm: "1.2rem !important",
      md: "1.3rem !important",
      lg: "1.3rem !important",
      xl: "1.4rem !important",
    },
    ml: 1.5
  };


  const actionButtonStyles = {
    textTransform: "none !important",
    fontSize: {
      xs: "0.8rem !important",
      sm: "0.9rem !important",
      md: "1rem !important",
      lg: "1rem !important",
      xl: "1.1rem !important",
    },
    fontWeight: "500 !important",
    px: {
      xs: "12px !important",
      sm: "16px !important",
      md: "18px !important",
      lg: "20px !important",
      xl: "22px !important",
    },
    py: {
      xs: "6px !important",
      sm: "8px !important",
      md: "10px !important",
      lg: "10px !important",
      xl: "11px !important",
    },
    borderRadius: "12px !important",
    transition: "all 0.3s ease !important",
    minWidth: { xs: "auto", sm: "100px", md: "110px", lg: "120px" },
    "&:active": {
      transform: "translateY(0) !important",
      transition: "all 0.1s ease !important",
    },
    "& .MuiButton-startIcon": {
      transition: "transform 0.3s ease !important",
      marginRight: {
        xs: "4px !important",
        sm: "6px !important",
        md: "6px !important",
        lg: "8px !important",
      },
    },
    "&:hover .MuiButton-startIcon": {
      transform: "translateX(-2px) !important",
    },
  };

  const getNavbarStyles = () => {
    if (location.pathname === "/" || location.pathname === "/home" || location.pathname.startsWith("/guest/")) {
      return {
        bgcolor: "transparent",
        color: "#FFFFFF",
        borderColor: "#FFFFFF",
        buttonBg: "transparent",
        buttonColor: "#FFFFFF",
        buttonBorder: "2px solid #FFFFFF",
        buttonHoverBg: "#FFFFFF",
        buttonHoverColor: "#267b14",
      };
    }
    return {
      bgcolor: "#FFFFFF",
      color: "#267b14",
      borderColor: "#267b14",
      buttonBg: "transparent",
      buttonColor: "#267b14",
      buttonBorder: "1px solid #cc0000",
      buttonHoverBg: "#cc0000",
      buttonHoverColor: "#FFFFFF",
    };
  };

  const navbarStyles = getNavbarStyles();

  const handleLocationMenuClose = () => {
    setLocationAnchor(null);
    setLocationMenuOpen(false);
  };

  const handleOutletSelect = (outlet) => {
    selectOutlet(outlet);
    handleLocationMenuClose();
  };

  const isActivePath = (path) => {
    if (path === "/" || path === "/home") return location.pathname === "/" || location.pathname === "/home";
    return location.pathname.startsWith(path);
  };

  const getOutletServices = (outlet) => {
    const services = [];
    if (outlet.is_delivery_available) services.push("Delivery");
    if (outlet.is_takeaway_available) services.push("Takeaway");
    if (outlet.is_dine_in_available) services.push("Dine-in");
    return services;
  };

  const handleLoginModalOpen = (e) => {
    // console.log("Login Opened")
    if (loginUser?.username) {
      setAnchorEl(e.currentTarget);
    } else {
      setLoginModalOpen(true);
    }
  };

  useEffect(() => {
    // console.log("current page => ", pageUrl);
    const handleScroll = () => {
      if (window.scrollY === 0) {
        setShowImage(true);
      } else {
        setShowImage(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      {!isTableOrderRoute &&
        <Container
          maxWidth={false} // This makes container full width
          disableGutters // Remove default padding
          sx={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bgcolor: navbarStyles.bgcolor, // Background stretches full width
            boxShadow: "none",
            py: 3,
            zIndex: 10,
            transition: "all 0.3s ease",
            borderRadius: "0px !important",
            display: 'flex',
            justifyContent: 'center',
            height: { md: '154px' }, // Or set specific height like '80px'
          }}>
          <AppBar
            position="fixed"
            // elevation={2}
            sx={{
              maxWidth: '1440px',
              margin: '0 auto',
              top: 0,
              left: 0,
              right: 0,
              bgcolor: navbarStyles.bgcolor,
              boxShadow: "none",
              px: 2,
              py: 3,
              zIndex: 10,
              transition: "all 0.3s ease",
              borderRadius: "0px !important",
            }}
          >
            <Toolbar sx={{ display: "flex", justifyContent: "space-evenly" }}>
              {/* Mobile Menu Button */}
              <IconButton
                edge="start"
                aria-label="menu"
                onClick={() => setMobileMenuOpen(true)}
                sx={{
                  display: { xs: "flex", md: "none" },
                  color: navbarStyles.color,
                  p: 1,
                  borderRadius: 1,
                  "&:hover": {
                    bgcolor: navbarStyles.buttonHoverBg,
                    color: navbarStyles.buttonHoverColor,
                  },
                }}
              >
                <MenuIcon />
              </IconButton>

              {/* Logo */}
              <Box
                sx={{
                  alignItems: "center",
                  cursor: "pointer",
                }}
                onClick={() => navigate("/home")}
              >
                {restaurant?.logo_url ? (
                  <Box
                    component="img"
                    src={getImageProps(restaurant.logo_url).src}
                    alt="Logo"
                    sx={{
                      mr: 5,
                      width: { xs: 65, sm: 75, md: 100 },
                      height: { xs: 65, sm: 75, md: 100 },
                      borderRadius: "50%",
                      objectFit: "contain",
                      bgcolor: "white",
                      p: { xs: 0.5, md: 1 },
                      boxSizing: "border-box",
                      transition: "all 0.3s ease",
                    }}
                  />
                ) : (
                  <Box
                    sx={{
                      width: 60,
                      height: 60,
                      borderRadius: "50%",
                      bgcolor: "#FFFFFF",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#267b14",
                      fontWeight: "bold",
                      fontSize: "1.2rem",
                      transition: "all 0.3s ease",
                    }}
                  >
                    {restaurant?.name?.charAt(0) || "R"}
                  </Box>
                )}
              </Box>

              {/* CENTER — MENU ITEMS */}
              <Box
                sx={{
                  display: { xs: "none", md: "flex" },
                  gap: 4,
                  alignItems: "center",
                }}
              >
                {navigationItems.map((item) =>
                  item.label !== "Order Online" ? (
                    <Typography
                      key={item.path || item.label}
                      onClick={() => handleNavigation(item.path)}
                      sx={{
                        gap: 2,
                        color: isActivePath(item.path) || navbarStyles.bgcolor === "transparent" ? navbarStyles.color : "text.primary",
                        fontWeight: isActivePath(item.path)
                          ? "600 !important"
                          : "500 !important",
                        fontSize: {
                          xs: "0.8rem !important",
                          sm: "0.9rem !important",
                          md: "1rem !important",
                          lg: "1.1rem !important",
                          xl: "1.2rem !important",
                        },
                        px: {
                          xs: 1.5,
                          sm: 1.75,
                          md: 2,
                          lg: 2.5,
                        },
                        py: {
                          xs: 1,
                          sm: 1.125,
                          md: 1.25,
                        },
                        transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                        position: "relative",
                        overflow: "hidden",
                        borderRadius: "8px",
                        cursor: "pointer",
                        whiteSpace: "nowrap",
                        "&:active": {
                          transform: "translateY(0)",
                          transition: "all 0.1s ease",
                        },
                        "&::before": {
                          content: '""',
                          position: "absolute",
                          bottom: 0,
                          left: "50%",
                          width: isActivePath(item.path) ? "80%" : "0%",
                          height: "2px",
                          backgroundColor: navbarStyles.color,
                          transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                          transform: "translateX(-50%)",
                        },
                        "&:hover::before": {
                          width: "80%",
                        },
                      }}
                    >
                      {item.label}
                    </Typography>
                  ) : (
                    <Button
                      variant="contained"
                      endIcon={
                        <ArrowForward
                          sx={{
                            fontSize: {
                              xs: "1rem !important",
                              sm: "1.4rem !important",
                              md: "1.5rem !important",
                              lg: "1.6rem !important",
                            },
                          }}
                        />
                      }
                      onClick={() => navigate("/delivery")}
                      sx={{
                        bgcolor: "#cc0000",
                        color: "#F9F9F9 !important",
                        textTransform: "none !important",
                        fontSize: {
                          xs: "0.8rem !important",
                          sm: "0.9rem !important",
                          md: "1rem !important",
                          lg: "1.1rem !important",
                          xl: "1.2rem !important",
                        },
                        fontWeight: "600 !important",
                        px: {
                          xs: "16px !important",
                          sm: "20px !important",
                          md: "24px !important",
                          lg: "28px !important",
                        },
                        py: {
                          xs: "8px !important",
                          sm: "10px !important",
                          md: "12px !important",
                          lg: "14px !important",
                        },
                        borderRadius: "12px !important",
                        boxShadow: "0 4px 12px rgba(204, 0, 0, 0.2) !important",
                        transition: "all 0.3s ease !important",
                        minWidth: { xs: "80px", sm: "140px", md: "160px" },
                        "& .MuiButton-endIcon": {
                          transition: "transform 0.3s ease !important",
                          marginLeft: {
                            xs: "4px !important",
                            sm: "6px !important",
                            md: "8px !important",
                            lg: "10px !important",
                          },
                        },
                        "&:hover": {
                          bgcolor: "#990000 !important",
                          transform: "translateY(-2px)",
                          boxShadow:
                            "0 6px 20px rgba(204, 0, 0, 0.3) !important",
                        },
                        "&:hover .MuiButton-endIcon": {
                          transform: "translateX(4px) !important",
                        },
                      }}
                    >
                      Order Online
                    </Button>
                  )
                )}
              </Box>

              {/* RIGHT — ACTION BUTTONS */}
              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                {/* Mobile Order Button */}
                <Button
                  variant="contained"
                  endIcon={
                    <ArrowForward
                      sx={{
                        fontSize: {
                          xs: "1rem !important",
                          sm: "1.4rem !important",
                          md: "1.5rem !important",
                          lg: "1.6rem !important",
                        },
                      }}
                    />
                  }
                  onClick={() => navigate("/delivery")}
                  sx={{
                    display: { xs: "flex", sm: "none" },
                    bgcolor: "#cc0000 !important",
                    color: '#F9f9f9 ',
                    textTransform: "none !important",
                    fontSize: {
                      xs: "0.8rem !important",
                      sm: "0.9rem !important",
                      md: "1rem !important",
                      lg: "1.1rem !important",
                      xl: "1.2rem !important",
                    },
                    fontWeight: "600 !important",
                    px: {
                      xs: "12px !important",
                      sm: "16px !important",
                      md: "18px !important",
                    },
                    py: {
                      xs: "6px !important",
                      sm: "8px !important",
                      md: "10px !important",
                    },
                    borderRadius: "12px !important",
                    boxShadow: "0 4px 12px rgba(204, 0, 0, 0.2) !important",
                    transition: "all 0.3s ease !important",
                    minWidth: "80px",
                    "&:hover": {
                      bgcolor: "#990000 !important",
                    },
                  }}
                >
                  Order
                </Button>

                {/* Shopping Cart Button */}
                <Button
                  variant="outlined"
                  startIcon={<ShoppingCart sx={iconStyles} />}
                  onClick={() => {
                    if (window.location.pathname !== "/checkout") {
                      setCartOpen(true)
                    }
                    else {
                      navigate('/delivery')
                      setCartOpen(true)
                    }
                  }
                  }
                  sx={{
                    ...actionButtonStyles,
                    color: `${navbarStyles.buttonColor} !important`,
                    border: `${navbarStyles.buttonBorder} !important`,
                    bgcolor: `${navbarStyles.buttonBg} !important`,
                    "&:hover": {
                      bgcolor: `${navbarStyles.buttonHoverBg} !important`,
                      color: `${navbarStyles.buttonHoverColor} !important`,
                    },
                  }}
                >
                  <Badge
                    badgeContent={cart.length || 0}
                    color="error"
                    sx={{
                      "& .MuiBadge-badge": {
                        fontSize: "0.7rem",
                        minWidth: "16px",
                        height: "16px",
                      },
                    }}
                  >
                    <Box
                      sx={{
                        display: { xs: "none", sm: "block" },
                        fontSize: "inherit",
                      }}
                    >
                      Cart
                    </Box>
                  </Badge>
                </Button>

                {/* Store Button */}
                <Button
                  variant="outlined"
                  startIcon={<Store sx={iconStyles} />}
                  onClick={() => {
                    if (window.location.pathname !== "/checkout") {
                      showOutletSelection();
                    } else {
                      navigate('/delivery');
                      showOutletSelection();
                    }
                  }}
                  sx={{
                    ...actionButtonStyles,
                    display: { xs: "none", lg: "flex" },
                    color: `${navbarStyles.buttonColor} !important`,
                    border: `${navbarStyles.buttonBorder} !important`,
                    bgcolor: `${navbarStyles.buttonBg} !important`,
                    "&:hover": {
                      bgcolor: `${navbarStyles.buttonHoverBg} !important`,
                      color: `${navbarStyles.buttonHoverColor} !important`,
                    },
                    width: "175px !important",
                    overflow: "hidden",
                    px: 1,
                    gap: 1, // Space between icon and text
                    // 🔥 animation keyframes here
                    "@keyframes scrollText": {
                      "0%": { transform: "translateX(0%)" },
                      "100%": { transform: "translateX(-50%)" },
                    },
                  }}
                >
                  {/* Text container with overflow hidden */}
                  <Box
                    sx={{
                      flex: 1,
                      overflow: "hidden",
                      position: "relative",
                    }}
                  >
                    <Box
                      sx={{
                        display: "inline-block",
                        whiteSpace: "nowrap",
                        animation: selectedOutlet?.name?.length > 10
                          ? `scrollText ${Math.max(5, selectedOutlet.name.length * 0.2)}s linear infinite`
                          : "none",
                        ...(selectedOutlet?.name?.length > 10 && {
                          "&:hover": {
                            animationPlayState: "paused", // Pause on hover for better UX
                          },
                        }),
                      }}
                    >
                      {/* Duplicate text for seamless looping */}
                      {selectedOutlet?.name || "Stores"}
                      {selectedOutlet?.name?.length > 10 && (
                        <span style={{ marginLeft: "40px" }}>
                          {selectedOutlet?.name || "Stores"}
                        </span>
                      )}
                    </Box>
                  </Box>
                </Button>

                {/* Login Button */}
                <Button
                  variant="outlined"
                  startIcon={<Person sx={iconStyles} />}
                  onClick={(e) => handleLoginModalOpen(e)}
                  sx={{
                    ...actionButtonStyles,
                    color: `${navbarStyles.buttonColor} !important`,
                    border: `${navbarStyles.buttonBorder} !important`,
                    bgcolor: `${navbarStyles.buttonBg} !important`,
                    "&:hover": {
                      bgcolor: `${navbarStyles.buttonHoverBg} !important`,
                      color: `${navbarStyles.buttonHoverColor} !important`,
                    },
                  }}
                >
                  <Box
                    sx={{
                      display: { xs: "none", sm: "inline" },
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      maxWidth: "100px",
                    }}
                  >
                    {loginUser?.username || "Login"}
                  </Box>
                  {loginUser?.username && (
                    <Box
                      sx={{
                        display: { xs: "flex", sm: "none" },
                        fontSize: "inherit",
                      }}
                    >
                      {loginUser?.username?.charAt(0).toUpperCase()}
                    </Box>
                  )}
                </Button>
              </Box>
            </Toolbar>
          </AppBar>
        </Container>}

      {/* Profile Menu */}
      {!isTableOrderRoute &&
        <Menu
          Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={() => setAnchorEl(null)}
          slotProps={{
            list: {
              "aria-labelledby": "basic-button",
            },
          }}
          PaperProps={{
            sx: {
              mt: 1,
              borderRadius: 1.5,
              boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
            },
          }}
        >
          <MenuItem
            onClick={() => navigate("/profile")}
            sx={{
              py: 1.5,
              px: 2,
              "&:hover": { bgcolor: navColor.hover },
            }}
          >
            <Person style={{ marginRight: 8 }} /> Profile
          </MenuItem>
          <MenuItem
            onClick={() => {
              // localStorage.setItem("User Navbar", "YES")
              localStorage.removeItem("access_token");
              localStorage.removeItem("refresh_token");
              localStorage.removeItem("cart_items");
              sessionStorage.removeItem("user");
              setAnchorEl(null);
              navigate("/homepage");
              showSuccess("User Logged Out Successfully");
              window.location.reload();
            }}
            sx={{
              py: 1.5,
              px: 2,
              "&:hover": { bgcolor: navColor.hover },
            }}
          >
            <Logout style={{ marginRight: 8 }} /> Logout
          </MenuItem>
        </Menu>}

      {/* Mobile Drawer */}
      {!isTableOrderRoute &&
        <Drawer
          Drawer
          anchor="left"
          open={mobileMenuOpen}
          onClose={() => setMobileMenuOpen(false)}
          sx={{ zIndex: (theme) => theme.zIndex.drawer + 3 }}
          PaperProps={{
            sx: {
              width: { xs: "75vw", sm: 280 },
              maxWidth: "280px",
              bgcolor: navColor.bg,
              borderRadius: 0, // Remove border radius
            },
          }}
        >
          <Box sx={{ p: 2, textAlign: "center" }}>
            {restaurant?.logo_url ? (
              <Box
                component="img"
                src={getImageProps(restaurant.logo_url).src}
                sx={{
                  width: 60,
                  height: 60,
                  mx: "auto",
                  mb: 1,
                  borderRadius: "50%",
                  objectFit: "contain",
                  bgcolor: "white",
                  p: 1,
                  boxSizing: "border-box",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                }}
              />
            ) : (
              <Box
                sx={{
                  width: 60,
                  height: 60,
                  mx: "auto",
                  mb: 1,
                  borderRadius: "50%",
                  background: "linear-gradient(135deg, #D4AF37 0%, #C19A6B 100%)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "white",
                  fontWeight: "bold",
                  fontSize: "1.5rem",
                }}
              >
                {restaurant?.name?.charAt(0) || "R"}
              </Box>
            )}
            <Typography
              variant="h6"
              fontWeight="bold"
              gutterBottom
              sx={{ color: navColor.text }}
            >
              {restaurant?.name || "Restaurant"}
            </Typography>
            <Typography
              variant="body2"
              sx={{ color: navColor.textSecondary, mb: 1 }}
            >
              {restaurant?.tagline || "Delicious food, great service"}
            </Typography>
          </Box>

          <Divider />

          <List sx={{ px: 1, py: 1 }}>
            {navigationItems.map((item) =>
              item.label !== "Order Online" ? (
                <ListItem key={item.path || item.label} disablePadding>
                  <ListItemButton
                    onClick={() => handleNavigation(item.path)}
                    sx={{
                      borderRadius: 1.5,
                      mb: 0.5,
                      py: 1.5,
                      bgcolor: isActivePath(item.path)
                        ? navColor.hover
                        : "transparent",
                      color: isActivePath(item.path)
                        ? navColor.primary
                        : navColor.text,
                      "&:hover": {
                        bgcolor: navColor.hover,
                        color: navColor.primary,
                      },
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        color: "inherit",
                        minWidth: 40,
                      }}
                    >
                      {item.icon}
                    </ListItemIcon>
                    <ListItemText
                      primary={item.label}
                      sx={{
                        "& .MuiListItemText-primary": {
                          fontSize: "1rem",
                          fontWeight: isActivePath(item.path) ? 600 : 400,
                        },
                      }}
                    />
                  </ListItemButton>
                </ListItem>
              ) : (
                <Button
                  fullWidth
                  variant="contained"
                  startIcon={<LocalShipping />}
                  onClick={() => {
                    navigate("/delivery");
                    setMobileMenuOpen(false);
                  }}
                  sx={{
                    borderRadius: "12px",
                    padding: "16px 24px",
                    backgroundColor: "#cc0000",
                    color: "#F9F9F9",
                    fontSize: "12px !important",
                    fontWeight: 600,
                  }}
                >
                  Order Online
                </Button>
              )
            )}
          </List>

          <Divider />

          <Box sx={{ p: 2 }}>
            <Button
              fullWidth
              variant="outlined"
              startIcon={<Store />}
              onClick={() => {
                showOutletSelection();
                setMobileMenuOpen(false);
              }}
              sx={{
                mb: 1.5,
                py: 1.5,
                fontSize: "0.9rem",
                textTransform: "none",
                borderRadius: 1.5,
                color: "#267b14 !important",
                border: "1px solid #cc0000 !important",
                "&:hover": {
                  color: "#FFFFFF !important",
                  bgcolor: "#cc0000 !important",
                  border: "1px solid #cc0000 !important",
                  boxShadow: "0 6px 20px rgba(204, 0, 0, 0.2) !important",
                  transform: "translateY(-2px) !important",
                },
              }}
            >
              <Box
                sx={{
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  maxWidth: "180px",
                }}
              >
                {selectedOutlet?.name || "Select Outlet"}
              </Box>
            </Button>
          </Box>
        </Drawer>}

      {/* Location Menu */}
      {!isTableOrderRoute &&
        <Menu
          Menu
          anchorEl={locationAnchor}
          open={locationMenuOpen}
          onClose={handleLocationMenuClose}
          PaperProps={{
            sx: {
              minWidth: 300,
              borderRadius: 1.5,
              mt: 1,
              maxHeight: "70vh",
              boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
            },
          }}
        >
          <Box sx={{ p: 2, borderBottom: "1px solid", borderColor: "divider" }}>
            <Typography
              variant="subtitle2"
              fontWeight="600"
              color="text.secondary"
            >
              Select Your Outlet
            </Typography>
            <Typography variant="caption" color="text.secondary">
              Choose an outlet to see available menu items and services
            </Typography>
          </Box>

          {(outlets || []).map((outlet) => {
            const services = getOutletServices(outlet);
            const isSelected = selectedOutlet?.id === outlet?.id;

            return (
              <MenuItem
                key={outlet?.id}
                onClick={() => handleOutletSelect(outlet)}
                selected={isSelected}
                sx={{
                  py: 2,
                  px: 2,
                  borderBottom: "1px solid",
                  borderColor: "divider",
                  "&:last-child": { borderBottom: "none" },
                  "&:hover": {
                    bgcolor: navColor.hover,
                  },
                  "&.Mui-selected": {
                    bgcolor: navColor.hover,
                    "&:hover": {
                      bgcolor: navColor.hover,
                    },
                  },
                }}
              >
                <Box sx={{ width: "100%" }}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "flex-start",
                      mb: 1,
                    }}
                  >
                    <Typography variant="body1" fontWeight="600">
                      {outlet?.name}
                    </Typography>
                    {isSelected && (
                      <Chip
                        label="Selected"
                        size="small"
                        color="primary"
                        variant="outlined"
                        sx={{ fontSize: "0.9rem" }}
                      />
                    )}
                  </Box>

                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ mb: 1.5 }}
                  >
                    {outlet?.address}
                  </Typography>

                  {services.length > 0 && (
                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                      {services.map((service) => (
                        <Chip
                          key={service}
                          label={service}
                          size="small"
                          variant="outlined"
                          color="success"
                          sx={{
                            fontSize: "0.65rem",
                            height: 20,
                            "& .MuiChip-label": { px: 1 },
                          }}
                        />
                      ))}
                    </Box>
                  )}

                  {services.length === 0 && (
                    <Typography variant="caption" color="warning.main">
                      No services available
                    </Typography>
                  )}
                </Box>
              </MenuItem>
            );
          })}

          {(outlets || []).length === 0 && (
            <MenuItem disabled sx={{ py: 2, px: 2 }}>
              <Box sx={{ textAlign: "center", width: "100%" }}>
                <Typography variant="body2" color="text.secondary">
                  No outlets available
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  Please check back later
                </Typography>
              </Box>
            </MenuItem>
          )}
        </Menu>}

      {/* Outlet Selection Modal */}
      {!isTableOrderRoute &&
        <OutletSelectionModal
          open={showOutletSelectionModal}
          onClose={closeOutletSelection}
          onOutletSelect={handleOutletSelection}
        />}

      {/* Login Modal */}
      {!isTableOrderRoute &&
        <LoginModal
          loginModalOpen={loginModalOpen}
          setLoginModalOpen={setLoginModalOpen}
        />}

      {/* Cart Drawer */}
      {!isTableOrderRoute &&
        <CartDrawer
          open={cartOpen}
          onClose={() => setCartOpen(false)}
          onCheckout={(serviceType, value) => {
            if (serviceType === "guest-signup") {
              let typeToUse = value || actualServiceType;
              // console.log("Yes Here the Service Type is :", typeToUse);
              navigate("/guest-signup", { state: { serviceType: typeToUse } });
            }
          }}
          actualServiceType={actualServiceType}
          setActualServiceType={setActualServiceType}
        />}

      {/* Contact Modal */}
      {!isTableOrderRoute &&
        <ContactModal
          contactModalOpen={contactModalOpen}
          setContactModalOpen={setContactModalOpen}
          restaurant={restaurant}
        />}
      <Outlet />

    </>
  );
};

export default UserNavbar;
